import { connect } from 'react-redux';
import { FrameworkActionCreator, RDWVehicleActionCreator, NewVehicleActionCreator, SpgVehicleActionCreator } from 'src/store/states';
import { IStoreState } from 'src/store';
import PropertyOptions from '../PropertyOptions';

const mapStateToProps = (state: IStoreState) => ({
    optionsSelected: state.NewVehicle.NewVehicle,
    vehicleSpecs: state.Specs.specs,
    rdwYears: state.RDWVehicle.years,
    rdwMakes: state.RDWVehicle.makes,
    rdwModels: state.RDWVehicle.models,
    theme: state.Framework.theme,
    currentProperty: state.NewVehicle.CurrentProperty,
    addlTrackYear: state.Framework.addlTrackYear,
    addlTrackMake: state.Framework.addlTrackMake,
    addlTrackModel: state.Framework.addlTrackModel,
    defaultLen: state.Specs.specs?.validMakes.length ?? 0,
    Itype: state.Framework.ImageServerType,
    mainPaneViewOrder: state.Framework.mainPaneViewOrder,
    makesBuilt: state.RDWVehicle.rdwMakesBuilt,
    yearsBuilt: state.RDWVehicle.rdwYearsBuilt,
    modelsBuilt: state.RDWVehicle.rdwModelsBuilt,
    sessionId: state.Framework.sessionId,
    lexusMCLaunched: state.Framework.lexusMCLaunched,
    toyotaMCLaunched: state.Framework.toyotaMCLaunched,
    lexusTDMCLaunched: state.Framework.lexusTDMCLaunched,
    toyotaTDMCLaunched: state.Framework.toyotaTDMCLaunched,
    colorSensitiveEnabled: state.Framework.colorSensitiveEnabled,
    spgOptions: state.SpgVehicle.options,
    spgEngines: state.SpgVehicle.engines,
    optionsBuilt: state.SpgVehicle.optionsBuilt,
    enginesBuilt: state.SpgVehicle.enginesBuilt,
    optionsKey: state.SpgVehicle.optionsKey,
    enginesKey: state.SpgVehicle.enginesKey,
    spgModels: state.SpgVehicle.spgModels,
    spgModelsBuilt: state.SpgVehicle.spgModelsBuilt,
    spgModelsKey: state.SpgVehicle.spgModelsKey,
});

const mapDispatchToProps = {
    onAddNewVehicle: NewVehicleActionCreator.AddNewVehicle,
    pushToLeftPane: FrameworkActionCreator.pushToLeftPane,
    getYears: RDWVehicleActionCreator.GetVehicleYears,
    getMakes: RDWVehicleActionCreator.GetVehicleMakes,
    getModels: RDWVehicleActionCreator.GetVehicleModels,
    getStyles: RDWVehicleActionCreator.GetEraStyles,
    vinDecode: RDWVehicleActionCreator.VinDecode,
    setAddVehicle: FrameworkActionCreator.SetAddVehicle,
    getSpgOptions: SpgVehicleActionCreator.GetSpgOptions,
    getSpgEngines: SpgVehicleActionCreator.GetSpgEngines,
    getSpgModels: SpgVehicleActionCreator.GetSpgModels,
    clearSpgVehicle: SpgVehicleActionCreator.ClearSpgVehicle,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(PropertyOptions);